import React from 'react';
import { pokemonData, pokemonTypes } from '../data/pokemonData';

function SitemapPage() {
  const baseUrl = 'https://example.com';
  const currentDate = new Date().toISOString().split('T')[0];

  const generateSitemap = () => {
    const urls = [];

    // Homepage
    urls.push({
      loc: baseUrl,
      lastmod: currentDate,
      changefreq: 'daily',
      priority: '1.0'
    });

    // Static pages
    const staticPages = [
      { path: '/pokemon', priority: '0.9', changefreq: 'daily' },
      { path: '/types', priority: '0.8', changefreq: 'weekly' },
      { path: '/compare', priority: '0.7', changefreq: 'monthly' },
      { path: '/search', priority: '0.7', changefreq: 'monthly' },
      { path: '/about', priority: '0.6', changefreq: 'monthly' },
      { path: '/contact', priority: '0.5', changefreq: 'yearly' },
      { path: '/terms', priority: '0.3', changefreq: 'yearly' },
      { path: '/privacy', priority: '0.3', changefreq: 'yearly' }
    ];

    staticPages.forEach(page => {
      urls.push({
        loc: `${baseUrl}${page.path}`,
        lastmod: currentDate,
        changefreq: page.changefreq,
        priority: page.priority
      });
    });

    // Pokemon detail pages
    pokemonData.forEach(pokemon => {
      urls.push({
        loc: `${baseUrl}/pokemon/${pokemon.name}`,
        lastmod: currentDate,
        changefreq: 'weekly',
        priority: '0.8'
      });
    });

    // Type pages
    pokemonTypes.forEach(type => {
      urls.push({
        loc: `${baseUrl}/type/${type.name}`,
        lastmod: currentDate,
        changefreq: 'weekly',
        priority: '0.7'
      });
    });

    // Top rankings pages
    const topPages = ['fastest', 'strongest', 'bulkiest', 'defensive', 'special-attack', 'special-defense'];
    topPages.forEach(page => {
      urls.push({
        loc: `${baseUrl}/top/${page}`,
        lastmod: currentDate,
        changefreq: 'weekly',
        priority: '0.6'
      });
    });

    return urls;
  };

  const sitemapXml = () => {
    const urls = generateSitemap();
    
    let xml = '<?xml version="1.0" encoding="UTF-8"?>\n';
    xml += '<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n';
    
    urls.forEach(url => {
      xml += '  <url>\n';
      xml += `    <loc>${url.loc}</loc>\n`;
      xml += `    <lastmod>${url.lastmod}</lastmod>\n`;
      xml += `    <changefreq>${url.changefreq}</changefreq>\n`;
      xml += `    <priority>${url.priority}</priority>\n`;
      xml += '  </url>\n';
    });
    
    xml += '</urlset>';
    return xml;
  };

  // Set content type for XML
  React.useEffect(() => {
    document.querySelector('meta[name="content-type"]')?.setAttribute('content', 'application/xml');
  }, []);

  return (
    <pre style={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap', margin: 0, padding: '20px' }}>
      {sitemapXml()}
    </pre>
  );
}

export default SitemapPage;